const companyPrefix = 'c';

export function companySlugTo(slug: string, location: string, extras: string = '') {
  return `/${companyPrefix}/${slug}/${location}` + extras;
}
